import { Component, Input, OnInit } from '@angular/core';
import { AuctionsWalletItem, MarketplaceWalletItem, WalletItemType } from '@fgb/core';

@Component({
  selector: 'fgbcl-rewards-wallet-redeemed-list-item',
  templateUrl: './rewards-wallet-redeemed-list-item.component.html',
  styleUrls: ['./rewards-wallet-redeemed-list-item.component.scss'],
})
export class RewardsWalletRedeemedListItemComponent implements OnInit {
  @Input() item: MarketplaceWalletItem;
  @Input() auctionItem: AuctionsWalletItem;
  @Input() ignoreLink: boolean = false;
  itemType = WalletItemType;

  constructor() {}

  ngOnInit(): void {}
}
